/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from 'react'
import { PageTitle } from '../../../../_metronic/layout/core';
import { Tr } from '../../../../_metronic/i18n/Tr';
import { useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment';
import { fetchData, formatNumber, getTranslatedValue, toasterrormsg } from '../../../../reusable';
import { ToastContainer } from 'react-toastify';
import { useLang } from '../../../../_metronic/i18n/Metronici18n';
import { formatDuration } from '../../advertisement/bannerAdvertisement/AddAdvertisement.constants';

// register the non-english moment locales used by the language switcher
require('moment/locale/ru')
require('moment/locale/uz-latn')

// app language code -> moment locale (uz translations use the latin script)
const momentLocales: any = {en: 'en', ru: 'ru', uz: 'uz-latn'}

const ViewCarBookingDetails = () => {
    const t = Tr()
    const lang = useLang()
    const navigate = useNavigate()
    const categoryId = sessionStorage.getItem('categoryId');
    useEffect(() => {
        if (categoryId != '7') {
            navigate('../dashboard/');
        }
    }, [categoryId])

    const location = useLocation();
    const [bookingDetails, setBookingDetails] = useState([]) as any;
    const [booking, setBooking] = useState({}) as any;
    const [userDetail, setUserDetail] = useState({}) as any;
    const [preDiscountAmount, setPreDiscountAmount] = useState('') as any
    const [discountPerncentage, setDiscountPercentage] = useState('') as any
    const [couponType, setCouponType] = useState("")
    const [couponValue, setCouponValue] = useState("")

    // user location, falling back to "region, country" when the api sends no location
    const getUserLocation = () => {
        if (userDetail['location']?.trim()) {
            return userDetail['location']
        }
        const region = userDetail['regionDetail']?.[0]
        const country = userDetail['countryDetail']?.[0]
        const regionName = region
            ? getTranslatedValue(lang, region, '_name', 'English') || region['name'] || ''
            : ''
        const countryName = country ? country['nicename'] || country['name'] || '' : ''
        return [regionName, countryName].filter(Boolean).join(', ')
    }

    const bookingId = (location.state as any)?.bookingId || '';

    const formatDate = (date: any) => {
        if (!date) {
            return ''
        }
        return moment(date)
            .locale(momentLocales[lang] || 'en')
            .format('ddd, DD MMM YYYY')
            .toUpperCase()
    };
    // view profile api call
    const bookingDetailsApiCall = async () => {

        var param: any = {
            bookingId: bookingId,
            categoryId: categoryId
        }
        var response: any = await fetchData("public/bookingDetail", param)
        if (response.status == "200") {
            var data = response.data
            setUserDetail(data[0]['userDetail'][0])
            setBooking(data[0])
            setBookingDetails(data[0]['bookingDetail'])
            setPreDiscountAmount(data[0].discount)
            setDiscountPercentage(data[0]['bookingDetail'][0]?.vendorDiscountPercentage)
            var couponData = data[0]['couponDetail']
            if (Object.keys(couponData).length > 0) {
                setCouponType(couponData['couponType'] ? couponData['couponType'] : '')
                setCouponValue(couponData['couponValue'])
            }
        }
        else {
            toasterrormsg(response.message)
        }
    }
    useEffect(() => {
        bookingDetailsApiCall()
    }, [bookingId])

    const getNumberOfHoursTimeFromDateTime = (fromDateTime: any, toDateTime: any) => {
        const start = moment(fromDateTime, 'DD-MM-YYYY HH:mm');
        const end = moment(toDateTime, 'DD-MM-YYYY HH:mm');

        // Calculate the difference in hours
        const duration = end.diff(start, 'hours', true);

        return duration;
    }
    return (
        <>
            <ToastContainer />
            <PageTitle breadcrumbs={[]}>{t('View Booking Details')}</PageTitle>
            <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
                <div className='card-header'>
                    <div className='card-title m-0'>
                        <h3 className='fw-bolder m-0'>{t('Booking Details')}</h3>
                    </div>
                </div>
                <div className='card-body p-9'>
                    <div className='row mb-7'>
                        <label className='col-lg-4 fw-bold text-muted'>{t('Booking ID')}</label>

                        <div className='col-lg-8'>
                            <span className='fw-bolder fs-6 text-dark'>#{booking['bookingCode']}</span>
                        </div>
                    </div>
                    <div className='row mb-7'>
                        <label className='col-lg-4 fw-bold text-muted'>{t('User Name')}</label>

                        <div className='col-lg-8'>
                            <span className='fw-bolder fs-6 text-dark'>{userDetail && userDetail['fullName']}</span>
                        </div>
                    </div>
                    <div className='row mb-7'>
                        <label className='col-lg-4 fw-bold text-muted'>{t('Date Booked')}</label>

                        <div className='col-lg-8'>
                            <span className='fw-bolder fs-6 text-dark'>{formatDate(booking['created'])}</span>
                        </div>
                    </div>
                    <div className='row mb-7'>
                        <label className='col-lg-4 fw-bold text-muted'>{t('User Location')}</label>

                        <div className='col-lg-8'>
                            <span className='fw-bolder fs-6 text-dark'>{getUserLocation()}</span>
                        </div>
                    </div>
                    <div className='row mb-7'>
                        <label className='col-lg-4 fw-bold text-muted'>{t('Payment Method')}</label>
                        <div className='col-lg-8'>
                            <span className='fw-bolder fs-6 text-dark'>{booking['paymentMethod'] ? booking['paymentMethod'] : ''}</span>
                        </div>
                    </div>
                </div>
            </div>
            {
                bookingDetails.map((detail: any, index: any) => {
                    var primaryLanguage = detail['actionDetail'][0]['primaryLanguage'] || '';
                    var supplierName = detail['actionDetail'].length > 0 ? getTranslatedValue(lang, detail['actionDetail'][0], '_supplierName') : '';
                    var careType = detail['actionTypeDetail'][0]['carcategoryDetail'] ? getTranslatedValue(lang, detail['actionTypeDetail'][0]['carcategoryDetail'][0], '_name', primaryLanguage) : '';

                    return (
                        <div className='card mb-5 mb-xl-10' id='kt_profile_details_view' key={index}>
                            <div className='card-header'>
                                <h3 className='card-title align-items-start flex-column'>
                                    <span className='card-label fw-bolder fs-3 mb-1'>{t('Booked Car')}</span>
                                </h3>
                            </div>
                            <div className='card-body p-9'>
                                <div className='row mb-7'>
                                    <label className='col-lg-4 fw-bold text-muted'>{t('Car Type')}</label>

                                    <div className='col-lg-8'>
                                        <span className='fw-bolder fs-6 text-dark'>{careType}</span>
                                    </div>
                                </div>
                                <div className='row mb-7'>
                                    <label className='col-lg-4 fw-bold text-muted'>{t('Supplier Name')}</label>

                                    <div className='col-lg-8'>
                                        <span className='fw-bolder fs-6 text-dark'>{supplierName}</span>
                                    </div>
                                </div>
                                <div className='row mb-7'>
                                    <label className='col-lg-4 fw-bold text-muted'>{t('Car Name')}</label>

                                    <div className='col-lg-8'>
                                        {detail['actionTypeDetail'] && detail['actionTypeDetail'].map((actionTypeDetail: any, index: any) => {
                                            return <div key={index} className="fw-bolder fs-6 text-dark mt-0">
                                                {getTranslatedValue(lang, actionTypeDetail, '_name', primaryLanguage)}
                                                {index !== detail['actionTypeDetail'].length - 1 ? ', ' : ''}
                                            </div>
                                        })}
                                        <span className='fw-bolder fs-6 text-dark'></span>
                                    </div>
                                </div>
                                <div className='row mb-7'>
                                    <label className='col-lg-4 fw-bold text-muted'>{t('Total Cars')}</label>
                                    <div className='col-lg-8'>
                                        <span className='fw-bolder fs-6 text-dark'>{detail['actionTypeDetail'].length}</span>
                                    </div>
                                </div>
                                <div className='row mb-7'>
                                    <label className='col-lg-4 fw-bold text-muted'>{t('Pick Up Date')}</label>
                                    <div className='col-lg-8'>
                                        <span className='fw-bolder fs-6 text-dark'>
                                            {detail['pickupDate'] ? detail['pickupDate'] : ''}
                                        </span>
                                    </div>
                                </div>
                                <div className='row mb-7'>
                                    <label className='col-lg-4 fw-bold text-muted'>{t('Drop Off Date')}</label>
                                    <div className='col-lg-8'>
                                        <span className='fw-bolder fs-6 text-dark'>
                                            {detail['dropoffDate'] ? detail['dropoffDate'] : ''}
                                        </span>
                                    </div>
                                </div>
                                <div className='row mb-7'>
                                    <label className='col-lg-4 fw-bold text-muted'>{t('Pick-Up Address')}</label>
                                    <div className='col-lg-8'>
                                        <span className='fw-bolder fs-6 text-dark'>
                                            {detail['actionDetail'][0]['pickupBranchAddress'] ? detail['actionDetail'][0]['pickupBranchAddress'] : ''}
                                        </span>
                                    </div>
                                </div>
                                <div className='row mb-7'>
                                    <label className='col-lg-4 fw-bold text-muted'>{t('Drop-Off Address')}</label>
                                    <div className='col-lg-8'>
                                        <span className='fw-bolder fs-6 text-dark'>
                                            {detail['actionDetail'][0]['dropoffBranchAddress'] ? detail['actionDetail'][0]['dropoffBranchAddress'] : ''}
                                        </span>
                                    </div>
                                </div>
                                <div className='row mb-7'>
                                    <label className='col-lg-4 fw-bold text-muted'>{t('Total Renting Hours')}</label>
                                    <div className='col-lg-8'>
                                        <span className='fw-bolder fs-6 text-dark'>{(detail['pickupDate'] && detail['dropoffDate']) ? formatDuration(getNumberOfHoursTimeFromDateTime(detail['pickupDate'], detail['dropoffDate']), 'HOUR', lang) : '-'}</span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className={`card card-xl-stretch mb-0`}>
                                            {/* begin::Header */}
                                            <div className='card-header border-bottom-0 px-0'>
                                                <h3 className='card-title align-items-start flex-column'>
                                                    <span className='card-label fw-bolder fs-3 mb-1'>{t('Driver Info')}</span>
                                                </h3>
                                            </div>
                                            {/* end::Header */}
                                            {/* begin::Body */}
                                            <div className='card-body py-0 px-0'>
                                                <div className='tab-content'>
                                                    {/* begin::Tap pane */}
                                                    <div className='tab-pane fade show active' id='kt_table_widget_4_tab_1'>
                                                        {/* begin::Table container */}
                                                        <div className='table-responsive'>
                                                            {/* begin::Table */}
                                                            <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-3'>
                                                                {/* begin::Table head */}
                                                                <thead>
                                                                    <tr className='fw-bold rounded text-muted bg-light'>
                                                                        {/* <th className='p-0 w-50px'></th> */}
                                                                        <th className='ps-4 min-w-150px rounded-start'>{t('First Name & Middle Name')}</th>
                                                                        <th className='ps-4 min-w-150px rounded-start'>{t('Last Name')}</th>
                                                                        <th className='ps-4 min-w-150px rounded-start'>{t('Residency')}</th>
                                                                        <th className='ps-4 min-w-150px rounded-start'>{t('Flight Number')}</th>
                                                                        <th className='ps-4 min-w-150px rounded-start'>{t('Contact Number')}</th>
                                                                        <th className='ps-4 min-w-150px rounded-start'>{t('Email')}</th>
                                                                        <th className='ps-4 min-w-150px rounded-start'>{t('Age')}</th>
                                                                    </tr>
                                                                </thead>
                                                                {/* end::Table head */}
                                                                {/* begin::Table body */}
                                                                <tbody>
                                                                    {
                                                                        detail['driverDetail'] && (

                                                                            detail['driverDetail'].map((driver: any, index: any) => {
                                                                                return (
                                                                                    <tr key={index}>
                                                                                        <td className='text-start ps-3'>
                                                                                            <div className='text-dark fw-bold mb-1 fs-6'>{driver['firstNameMiddleName']}</div>
                                                                                        </td>
                                                                                        <td className='text-start ps-3'>
                                                                                            <div className='text-dark fw-bold mb-1 fs-6'>{driver['lastName']}</div>
                                                                                        </td>
                                                                                        <td className='text-start ps-3'>
                                                                                            <div className='text-dark fw-bold mb-1 fs-6'>{driver['residency']}</div>
                                                                                        </td>
                                                                                        <td className='text-start ps-3'>
                                                                                            <div className='text-dark fw-bold mb-1 fs-6'>{driver['flightNumber'] ? driver['flightNumber'] : '-'}</div>
                                                                                        </td>
                                                                                        <td className='text-start ps-3'>
                                                                                            <span className='text-dark fw-bold mb-1 fs-6'>{'+' + driver['countryCode'] + ' ' + driver['mobileNumber']}</span>
                                                                                        </td>
                                                                                        <td className='text-start ps-3'>
                                                                                            <span className='text-dark fw-bold mb-1 fs-6'>{driver['email']}</span>
                                                                                        </td>
                                                                                        <td className='text-start ps-3'>
                                                                                            <span className='text-dark fw-bold mb-1 fs-6'>{driver['age']}</span>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                        )
                                                                    }
                                                                </tbody>
                                                                {/* end::Table body */}
                                                            </table>
                                                            {
                                                                detail['driverDetail'].length == 0 && (
                                                                    <div className="row w-100">
                                                                        <div className="col-lg-12">
                                                                            <div className='text-gray-500 text-center fw-bold mb-1 fs-6'>{t('No Record Found.')}</div>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            }
                                                        </div>
                                                        {/* end::Table */}
                                                    </div>
                                                    {/* end::Tap pane */}
                                                </div>
                                            </div>
                                            {/* end::Body */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                })
            }
            <div className="row">
                <div className="col-lg-6">
                    <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
                        <div className='card-header'>
                            <div className='card-title m-0'>
                                <h3 className='fw-bolder m-0'>{t('Payment Details')}</h3>
                            </div>
                            <div className='card-title m-0'>
                                {
                                    booking['status'] == 2 && (
                                        <span className='btn btn-light-danger mx-2 p-1 btn-sm fw-bold w-100px pointer-events-none'>{t('Rejected')}</span>
                                    )
                                }
                                {
                                    booking['status'] == 3 && (
                                        <span className='btn btn-danger mx-2 p-1 btn-sm fw-bold w-100px pointer-events-none'>{t('Cancelled')}</span>
                                    )
                                }
                            </div>
                        </div>
                        <div className='card-body p-9'>
                            <div className='row mb-7'>
                                <label className='col-lg-4 fw-bold text-muted'>{t('Original Amount')}</label>
                                <div className='col-lg-8'>
                                    <span className='fw-bolder fs-6 text-dark'>{formatNumber(parseFloat(booking['subTotal']))} UZS</span>
                                </div>
                            </div>
                            <div className='row mb-7'>
                                <label className='col-lg-4 fw-bold text-muted'>{t('Extra People Charge')}</label>
                                <div className='col-lg-8'>
                                    {/* {/ Total Charge Calculation /} */}
                                    <span className='fw-bolder fs-6 text-dark'>
                                        {bookingDetails.length > 0 && bookingDetails[0]
                                            ? bookingDetails[0].extraPeople &&
                                                bookingDetails[0].extraPeople !== '0' &&
                                                bookingDetails[0].extraPeopleCharge &&
                                                bookingDetails[0].extraPeopleCharge !== '0'
                                                ? formatNumber(
                                                    parseFloat(bookingDetails[0].extraPeopleCharge) *
                                                    parseFloat(bookingDetails[0].extraPeople)
                                                )
                                                : 0
                                            : '0'}{' UZS'}
                                    </span>

                                    {/* {/ Breakdown Display /} */}
                                    <span className='fw-bolder fs-7 text-dark'>
                                        {bookingDetails.length > 0 &&
                                            bookingDetails[0] &&
                                            bookingDetails[0].extraPeople &&
                                            bookingDetails[0].extraPeople !== '' &&
                                            bookingDetails[0].extraPeopleCharge &&
                                            bookingDetails[0].extraPeopleCharge !== ''
                                            ? ` (${bookingDetails[0].extraPeople} x ${formatNumber(
                                                bookingDetails[0].extraPeopleCharge
                                            )} UZS)`
                                            : ' (0 x 0 UZS)'}
                                    </span>
                                </div>
                            </div>
                            <div className='row mb-7'>
                                <label className='col-lg-4 fw-bold text-muted'>{t('Extra Charge')}</label>
                                <div className='col-lg-8'>
                                    <span className='fw-bolder fs-6 text-dark'>{formatNumber(parseFloat(booking['extraCharge']))} UZS</span>
                                </div>
                            </div>
                            <div className='row mb-7'>
                                <label className='col-lg-4 fw-bold text-muted'>{t('User Points')}</label>
                                <div className='col-lg-8'>
                                    <span className='fw-bolder fs-6 text-dark'>{formatNumber(parseFloat(booking['pointAmount']))} UZS</span>
                                    <span className='fw-bold fs-7'> ({booking['point'] + ` ${t('points')}`})</span>
                                </div>
                            </div>
                            <div className='row mb-7'>
                                <label className='col-lg-4 fw-bold text-muted'>{t('Coupon Amount')}</label>
                                <div className='col-lg-8'>
                                    <span className='fw-bolder fs-6 text-dark'>
                                        {booking['couponDiscount'] == '' || booking['couponDiscount'] == undefined || booking['couponDiscount'] == null
                                            ? 0
                                            : formatNumber(parseFloat(booking['couponDiscount']))}{' '}
                                    </span>
                                    {/* {/ <span className='fw-bold fs-7'> (10% OFF coupon OR 15,000 UZS coupon)</span> /} */}
                                    <span className='fw-bolder fs-7 text-dark'>
                                        {' '}
                                        ({couponValue} {" "}
                                        {couponType == 'FIXED'
                                            ? t('UZS Coupon')
                                            : couponType == 'PERCENTAGE'
                                                ? t('% OFF coupon')
                                                : t('No Coupon Applied')}
                                        )
                                    </span>{' '}
                                </div>
                            </div>
                            <div className='row mb-7 pb-5 border-bottom border-gray-300'>
                                <label className='col-lg-4 fw-bold text-muted'>{t('Discount Amount')}</label>
                                <div className='col-lg-8'>
                                    <span className='fw-bolder fs-6 text-dark'>
                                        {preDiscountAmount == '' ? 0 : formatNumber(parseFloat(booking['discount']))}{' UZS'}
                                    </span>
                                    <span className='fw-bolder fs-7 text-dark'>
                                        {' '}
                                        (
                                        {bookingDetails[0] != undefined &&
                                            bookingDetails[0] != null &&
                                            bookingDetails[0] != '' &&
                                            bookingDetails[0].specialDiscount == 0
                                            ? discountPerncentage != ''
                                                ? discountPerncentage.toFixed(2) + ` % ${t('discount')}`
                                                : `0 % ${t('discount')}`
                                            : `${t('Special Discount')}`}
                                        )
                                    </span>{' '}
                                </div>
                            </div>
                            {
                                (booking['status'] == 2 || booking['status'] == 3) && (
                                    <>
                                        <div className='row py-3 border-bottom border-gray-300'>
                                            <label className='col-lg-4 fw-bold'>{t('Total Paid')}</label>
                                            <div className='col-lg-8'>
                                                <span className='fw-bolder fs-6 text-dark'>{formatNumber(parseFloat(booking['totalPaid']))} UZS</span>
                                            </div>
                                        </div>
                                        <div className='row py-3 border-bottom border-gray-300 text-danger'>
                                            <label className='col-lg-4 fw-bold'>{booking['status'] == 2 ? `${t('Refundable')}` : `${t('Cancellation')}`} {t('Amount')}</label>
                                            <div className='col-lg-8'>
                                                <span className='fw-bolder fs-6'>- {formatNumber(parseFloat(booking['bookingDetail'][0]['cancellationAmount'] || 0))} UZS</span>
                                                <span className='fw-bold fs-7'> ({(booking['bookingDetail'][0]['cancellationCharge']).toFixed(2)}% {t('refund')})</span>
                                            </div>
                                        </div>
                                    </>
                                )
                            }
                            <div className='row my-7'>
                                <label className='col-lg-4 fw-bold fs-6'>{t('Final Amount')}</label>
                                <div className='col-lg-8'>
                                    <span className='fw-bolder fs-6 text-dark'>{formatNumber(parseFloat(booking['totalAmount']))} UZS</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
                        <div className='card-header'>
                            <div className='card-title m-0'>
                                <h3 className='fw-bolder m-0'>{t('Insayr Commission')}</h3>
                            </div>
                        </div>
                        <div className='card-body p-9'>
                            <div className='row mb-7'>
                                <label className='col-lg-4 fw-bold text-muted'>{t('INSAYR Service Fee')}</label>
                                <div className='col-lg-8'>
                                    <span className='fw-bolder fs-6 text-dark'>{booking['insayrServiceRate'] ? parseFloat(booking['insayrServiceRate']).toFixed(2) : '0.00'}%</span>
                                </div>
                            </div>
                            <div className='row mb-7'>
                                <label className='col-lg-4 fw-bold text-muted'>{t('INSAYR Service Amount')}</label>
                                <div className='col-lg-8'>
                                    <span className='fw-bolder fs-6 text-dark'>{booking['insayrServiceFee'] ? formatNumber(parseFloat(booking['insayrServiceFee'])) : '0'} UZS</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export { ViewCarBookingDetails }